<template>
  <div>
    <DxDateBox
      :value="date"
      display-format="dd MMM yyyy"
      @valueChanged="onValueChange"
      :readOnly="readOnly"
      :max="maxDate"
      @key-down="onKeyDown"
    />
  </div>
</template>

<script>
import DxDateBox from "devextreme-vue/date-box";

export default {
  components: {
    DxDateBox,
  },
  props: {
    date: {
      type: Date,
      default: null,
    },
    columnData: {
      type: Object,
      default: () => {},
    },
    valueChangeCallBack: {
      type: Function,
      default: () => {},
    },
    gridData: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    onKeyDown: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      maxDate: undefined,
    };
  },
  created() {
    if (this.columnData.editorOptions)
      if (this.columnData.editorOptions.max)
        this.maxDate = this.columnData.editorOptions.max;
  },
  methods: {
    onValueChange(e) {
      if (this.columnData && this.columnData.editable) {
        this.valueChangeCallBack(e, this.gridData);
      }
    },
  },
};
</script>
